import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ButtonPrimary,
  FormInputField,
  CardSupport,
  ApiError,
  NavigationPageTitle,
  ScrollToTop,
  FocusFirstError,
  NavigationHeader
} from '@core/index';
import { appButtonType, appRoute, validCharRegex } from '@utils/globalConstant';
import { Form, Formik } from 'formik';
import { useActivation } from '@context/MobileOne';
import { useA11y } from '@context/Utils';
import { AppPageContentWrapper } from '@part/AppPageContentWrapper';
import { tA11y } from '@utils/a11y/a11yHelpers';

export function EmailVerification() {
  // Context
  const navigate = useNavigate();
  const { isGenericApiError } = useA11y();
  const { isLoading, validationSchemaEmail, verifyEmail, formError, setFormError } =
    useActivation();

  const onBacktoHomePage = () => {
    navigate(appRoute.HOME_PAGE);
  };

  const handleAPIErrorLink = () => {
    const firstInput = document.querySelector('input');
    if (firstInput) {
      firstInput.focus();
    }
  };

  useEffect(() => {
    // Reset form error when component mounts
    setFormError(false);
  }, []);

  return (
    <>
      <ScrollToTop>
        <div className="min-dvh-100">
          <NavigationHeader />
          <AppPageContentWrapper>
            <div className="pt-32">
              <NavigationPageTitle
                title="ek_reg_mail_hdl1"
                desc="ek_reg_mail_txt1"
                variant="lg"
                isBackButton
                onButtonClick={onBacktoHomePage}
              />
            </div>
            {/* BFSG: ONLY for TESTING of API ERROR BOXES, REMOVE AFTER TESTING */}
            {/* <p className="pb-8">{`API response contains field: 'isDefaultMsg' ----> ${isGenericApiError}`}</p> */}
            <Formik
              initialValues={{ email: '' }}
              validationSchema={validationSchemaEmail}
              onSubmit={verifyEmail}>
              {({
                values: { email },
                handleBlur,
                handleChange,
                handleSubmit,
                touched,
                errors,
                setFieldValue
              }) => {
                // BFSG: remove console.log
                // console.log(errors);
                return (
                  <Form className="mt-40" onSubmit={handleSubmit} noValidate>
                    <FormInputField
                      label="ek_global_email_lbl"
                      placeholder="ek_global_email_plc"
                      // hint="ek_global_email_info"
                      type="text"
                      id="email"
                      name="email"
                      inputMode="email"
                      value={email}
                      onChange={(e) => {
                        setFormError(false);
                        handleChange({
                          target: {
                            id: 'email',
                            name: 'email',
                            value: e.target.value
                          }
                        });
                      }}
                      onClear={setFieldValue}
                      onBlur={handleBlur}
                      valid={touched.email && !errors.email}
                      invalid={
                        (touched.email && errors.email) || !!(formError && !isGenericApiError)
                      }
                      invalidMessage={touched.email && errors.email ? errors.email : null}
                      aria-describedby="email-error-description"
                      checkCharRegex={validCharRegex.EMAIL}
                    />
                    {formError && (
                      <div className="form-text mt-40 ps-4" aria-live="polite">
                        <ApiError
                          message={formError}
                          isGenericApiError={isGenericApiError}
                          handleAPIErrorLink={handleAPIErrorLink}
                        />
                      </div>
                    )}
                    <div className="row justify-content-center">
                      <div className="col-lg-5 col-10 px-0 mx-auto">
                        <ButtonPrimary
                          buttonClass="my-40"
                          buttonType={appButtonType.PRIMARY}
                          buttonContent={tA11y('ek_reg_mail_btn1')}
                          label="ek_reg_mail_btn1"
                          type="submit"
                          isLoading={isLoading}
                        />
                      </div>
                    </div>
                    <FocusFirstError />
                  </Form>
                );
              }}
            </Formik>
            <CardSupport />
          </AppPageContentWrapper>
        </div>
      </ScrollToTop>
    </>
  );
}

export default EmailVerification;
